import _ from "lodash"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Card, CardBody, Col, Row, Table } from "reactstrap"
import { showModal } from "../../../slices/quotation/reducer"
import DeleteModal from "../../../Components/Common/DeleteModal"
import {
  getQuotationDetail,
  updateTransportation,
} from "../../../slices/thunks"
import { useLocation } from "react-router-dom"
// import DeleteModal from "../../../Components/Common/DeleteModal"

const Transportation = () => {
  const dispatch = useDispatch()
  const {
    transportation: { list },
  } = useSelector((state) => state.Quotation)

  const location = useLocation()

  const urlParams = new URLSearchParams(location.search)
  const qID = urlParams.get("q")

  const [reload, setReload] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteData, setDeleteData] = useState(null)
  const editTransportation = (data) => {
    let obj = {
      modal: true,
      modalType: "transportation",
      modalData: {
        ID: data?.ID || "",
        QuoteID: data?.QuoteID || "",
      },
    }
    dispatch(showModal(obj))
  }
  const onDeleted = () => {
    let obj = {
      ID: +deleteData?.ID,
      QuoteID: +deleteData?.QuoteID,
      OperationType: 12,
      IsActive: false,
    }
    dispatch(updateTransportation(obj)).then((res) => {
      setReload(!reload)
      if (res.payload && res.payload.Status === 200) {
        setDeleteModal(false)
        let quotationDetail = {
          ID: Number(qID),
        }

        dispatch(getQuotationDetail(quotationDetail))
      }
    })
  }

  const onClickDelete = (data) => {
    setDeleteModal(true)
    setDeleteData(data)
  }

  return (
    <Card className="border border-black">
      <CardBody>
        <Row>
          <Col md={12}>
            <h5>Transportation Details</h5>
            <hr></hr>
          </Col>
        </Row>
        <Col lg={12}>
          <div className="table-responsive mt-2">
            <Table
              className="align-middle table-nowrap mb-0"
              striped
              responsive
              hover
            >
              <thead>
                <tr>
                  <th scope="col">Vehicle Type</th>
                  <th scope="col">Pickup date </th>
                  <th scope="col">Drop Date</th>
                  <th scope="col">No of Days</th>
                  <th scope="col">Total Transport</th>
                  <th scope="col">Total With GST</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(list) && list.length ? (
                  list.map((trans, i) => {
                    return (
                      <tr key={i}>
                        <td scope="col">{trans?.VehicleTypeName}</td>
                        <td scope="col">{trans?.PickUpDate}</td>
                        <td scope="col">{trans?.DropDate}</td>
                        <td scope="col">{trans?.NoOfDays}</td>
                        <td scope="col">{trans?.Total}</td>
                        <td scope="col">{trans?.GrandTotal}</td>
                        <td scope="col">
                          {" "}
                          <div
                            className="hstack gap-3 flex-wrap "
                            role="button"
                          >
                            <i
                              className="ri-edit-line text-success fs-18"
                              //
                              onClick={() => editTransportation(trans)}
                            ></i>
                            <div className="gap-3 " role="button">
                              <i
                                className="ri-delete-bin-fill text-danger fs-18"
                                onClick={() => onClickDelete(trans)}
                              ></i>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )
                  })
                ) : list.length === 0 ? (
                  <tr>
                    <td colSpan={10} className="text-center">
                      No Transportation found
                    </td>
                  </tr>
                ) : null}
              </tbody>
              <tfoot>
                <tr>
                  <td className="text-end" colSpan={4}>
                    Total
                  </td>
                  <td>{_.round(_.sumBy(list, "Total"))}</td>
                  <td colSpan={2}>{_.round(_.sumBy(list, "GrandTotal"))}</td>
                </tr>
              </tfoot>
            </Table>
          </div>
          <DeleteModal
            show={deleteModal}
            onCloseClick={() => setDeleteModal(false)}
            onDeleteClick={() => onDeleted()}
          />
        </Col>
      </CardBody>
    </Card>
  )
}

export default Transportation
